<Teranet-PageTitle i18n="@@contactus_title" [PageTitle]="'Password Expiring'"></Teranet-PageTitle>
<div class="modal-body" mat-dialog-content>
  <p i18n="@@passwordexpire_message">Your password will be expiring in {{ days == 1 ? days + ' day' : days + ' days'  }}.</p>
</div>
<div mat-dialog-actions fxLayoutAlign="center space-around">
  <button mat-raised-button class="theme-button" [mat-dialog-close]="true" i18n="@@passwordexpire_btn_change_password">Change Password</button>
  <button mat-raised-button class="theme-button" mat-dialog-close i18n="@@passwordexpire_btn_login">Sign In</button>
</div>
